import { render, staticRenderFns } from "./LocalisedTimezone.vue?vue&type=template&id=048d7112&"
import script from "./LocalisedTimezone.vue?vue&type=script&lang=js&"
export * from "./LocalisedTimezone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports